<template>
    <div>
        <img class="d-block mx-auto" src="@/assets/images/icons/guide-icon.svg" width="80" alt="Illustration of people looking at an overhead projector on a training course.">
        <p class="text-center lead font-weight-bold mt-3">Please complete the GTT@home virtual training before using the Digostics Portal</p>
        <div class="d-flex align-items-center mt-45">
            <button @click="logout()" class="btn btn-cancel btn-lg lg-shadow d-flex flex-grow-1 w-40 justify-content-center align-items-center">Log out</button>
            <button @click="startTraining()" class="btn btn-success btn-lg lg-shadow d-flex flex-grow-1 ml-3 w-60 justify-content-center align-items-center">Start training</button>
        </div>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
    name: 'HCPMustCompleteTrainingModalComponent',

    props: {
        trainingStarted: Boolean
    },

    data() {
        return {
        }
    },

    methods: {
        ...mapActions({
            signout: 'UserStore/Signout'
        }),

        startTraining() {
            this.trainingStarted = true
            this.$emit('close')
            return this.$router.push({name: 'HCPTraining'})
        },

        async logout() {
            await this.signout()
        }
    }
}
</script>